import {
  Ability,
  AbilityBuilder
} from '@casl/ability'

export const ability = new Ability();

export const abilityPlugin = (store) => {
  return store.subscribe((mutation) => {
    if (mutation.type === "setUser") {
      const {
        rules,
        can
      } = AbilityBuilder.extract();
      // tworzenie rulsów
      const mainKeys = Object.keys(store.state.user.permissions);
      const read = [];
      const edit = [];
      for (let i = 0; i < mainKeys.length; i++) {
        if (mainKeys[i] == 'layers') {
          for(let [key, value] of Object.entries(store.state.user.permissions[mainKeys[i]])) {
            if (value.edit === 2) {
              edit.push(key);
            } else {
              read.push(key);
            }
          }
        } else {
          let subKeys = Object.keys(store.state.user.permissions[mainKeys[i]]);
          for(let j = 0; j < subKeys.length; j++) {
            if(store.state.user.permissions[mainKeys[i]][subKeys[j]] === 2) {
              edit.push(subKeys[j]);
            } else if(store.state.user.permissions[mainKeys[i]][subKeys[j]] === 1) {
              read.push(subKeys[j]);
            }
          }
        }
      }
      can('edit', edit);
      can('read', read);
      ability.update(rules);
    }
  });
};



// WEBPACK FOOTER //
// ./src/store/ability.js